import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';

const ListPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {

    return (
        <li className="ace-production-row">
            <div className="ace-production-image">
                <div className="ace-production-image-inner">
                    <img src={props.performance.imageUrl} alt={props.performance.imageAltText} />
                </div>
            </div>
            <div className="ace-production-info">
                <div className="stack-md">
                    <h3 data-demo-label="Performance Title">
                        {
                            props.performance.productionDetailPageLink != null && props.performance.productionDetailPageLink.length > 0 ?
                                <a target="_blank" href={props.performance.productionDetailPageLink} dangerouslySetInnerHTML={{ __html: props.performance.title }} />
                                :
                                <span dangerouslySetInnerHTML={{ __html: props.performance.title }} />
                        }
                    </h3>
                    <div>
                        <p>
                            {props.performance.performanceDateDayString} at {props.performance.performanceTimeString}
                        </p>
                        <p className="light">
                            <span>{props.performance.facility.facilityDescription}</span>
                        </p>
                    </div>
                </div>
            </div>
            {
                props.showReserveButton ?
                    <div className={"ace-production-cta"}>
                        <button className={props.performanceInCart ? 'btn-secondary' : 'btn-primary'} disabled={!props.performanceInCart && !props.allowReserve} onClick={() => {
                            if (props.performanceInCart) {
                                props.removeFromCart(props.performance.performanceId);
                            } else {
                                props.selectPerformance(props.performance, props.useUnSeatedReservation);
                            }
                        }}>
                            {props.performanceInCart ? props.text.removeButtonText : props.text.addToCartButtonText}
                        </button>
                    </div>
                    : null
            }

        </li>
    );
}

export default ListPerformanceView;